import React from 'react';

export default function ScoreSide({
    teamName,
    score,
    isWinner,
    onIncrement,
    onDecrement,
    colorClass
}) {
    return (
        <div className={`side ${colorClass} ${isWinner ? 'winner' : ''}`} onClick={onIncrement}>
            <button
                className="decrement-btn"
                onClick={(e) => {
                    e.stopPropagation();
                    onDecrement();
                }}
            >
                -
            </button>
            <h2>{teamName}</h2>
            <div className="score">{score}</div>
            {isWinner && <div className="winner-badge">WINNER</div>}
        </div>
    );
}
